var CurrentUser = require("lib/account/CurrentUser");
var LoadingButton = require("components/utility/LoadingButton");
require("appdev/wizards/clever_provisioning_form.scss");

class CleverProvisioningForm extends React.Component {

	constructor(props) {
		super();
		autobind(this);
		this.state = {
			startDate: '',
			product: 'wrGold',
			welcomeEmail: false,
			exemptEmails: '',
			contactName: '',
			existingTeachers: [],
			showExistingTeachers: false,
			loading: false
		};
	}

	////////////////////////////////
	/////////// Handlers ///////////
	////////////////////////////////

	excludeExisitingTeachers() {
		var { existingTeachers } = this.state
		var exemptEmails = _.compact(_.pluck(existingTeachers, 'email')).join(',')
		this.setState({ exemptEmails })
	}

	// On access code change, request token info from BE
	// Gather existing teachers
	getExistingTeachers = () => {
		var accessTokenID = this.props.accessToken.id

		var embed = "clever_access_token.district_org,district_org.teachers"

		CurrentUser.api().getCleverAccessToken(accessTokenID, { embed: embed }, $wr.apiHandler((response) => {
			var districtOrg = response.clever_access_token.district_org
			var existingTeachers = []
			if (districtOrg && districtOrg.teachers) {
				existingTeachers = _.filter(districtOrg.teachers, (t) => { return !_.isEmpty(t.last_active) })
			}
			this.setState({ existingTeachers });
		}))
	}

	handleInputChange = event => {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleCheckboxChange = event => {
		this.setState({
			welcomeEmail: event.target.checked, contactName: '', exemptEmails: '',
		});
	}

	handleSubmit(e) {
		$wr.nope(e)
		
		this.setState({ loading: true })

		var { startDate, product, welcomeEmail, exemptEmails, contactName } = this.state;
		var updateParams = {
			start_date: startDate,
			product: product,
			welcome_email: welcomeEmail,
			exempt_emails: exemptEmails,
			contact_name: contactName
		}

		CurrentUser.api().patchCleverAccessToken(this.props.accessToken.id, updateParams, $wr.apiHandler((response) => {
			this.setState({ loading: false })
			if (response.success) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", text: "You have provisioned a school.", icon: "ok-sign"
				});
			} else {
				window.wrNotifications.triggerDropDownNotification({
					title: "Oops!", text: "Something went wrong",
					type: "error", icon: "remove"
				}, 4000);
			}

			if (this.props.onSubmit) {
				this.props.onSubmit()
			}
		}));
	}

	////////////////////////////////
	//////// Render Methods ////////
	////////////////////////////////

	renderExistingTeachers() {
		var { existingTeachers, showExistingTeachers } = this.state
		if (!_.size(existingTeachers)) { return null }

		return (
			<div className="existing-teacher-display">
				<div className="expand-teachers-link">
					<a onClick={() => this.setState({ showExistingTeachers: !this.state.showExistingTeachers })}>{_.size(existingTeachers)} active teachers</a>
				</div>
				{showExistingTeachers && (
					<React.Fragment>
						<table className="table">
							<tbody>
								<tr>
									<th>ID</th>
									<th>Name</th>
									<th>Email</th>
									<th>Last Active</th>
								</tr>
								{_.map(existingTeachers, teacher => {
									return (
										<tr key={teacher.id}>
											<td>{teacher.id}</td>
											<td>{teacher.first_name} {teacher.last_name}</td>
											<td>{teacher.email}</td>
											<td>{$wr.formatDate(teacher.last_active)}</td>
										</tr>
									)
								})}
							</tbody>
						</table>
						<div className="exclude-link">
							<a onClick={this.excludeExisitingTeachers}>Exclude all from email</a>
						</div>
					</React.Fragment>
				)}
			</div>
		)
	}

	render() {
		var { startDate, product, welcomeEmail, exemptEmails, contactName } = this.state;

		return (
			<div className="cleverProvisioningForm">
				<h2>6 - Provision Sections</h2>
				<form className="clever-form" onSubmit={this.handleSubmit}>
					<div className="form-row">
						<div className="row-column">
							<label>
								Start Date
								<input type="date" name="startDate" value={startDate} onChange={this.handleInputChange} />
							</label>
						</div>

						<div className="row-column">
							<label>
								Product
								<select name="product" value={product} onChange={this.handleInputChange}>
									<option value="wrGold">Gold</option>
									{/* <option value="wrSilver">Silver</option> */}
								</select>
							</label>
						</div>
					</div>
					<label id="welcome-email-container">
						<input type="checkbox" checked={welcomeEmail} onChange={this.handleCheckboxChange} />
						Send welcome email
					</label>

					{welcomeEmail && (
						<React.Fragment>
							<label>
								Contact Name
								<input type="text" name="contactName" value={contactName} onChange={this.handleInputChange} placeholder="Contact Name" />
							</label>
							{this.renderExistingTeachers()}
							<label>
								Exclude Emails
								<textarea name="exemptEmails" value={exemptEmails} onChange={this.handleInputChange} placeholder="Exlude emails (comma separated)" />
							</label>
						</React.Fragment>
					)}

					{(startDate && product) && (
						<div className="btn-container">
							<LoadingButton className="btn buttonSuccess center-block"
								loading={this.state.loading} text="Submit" />
						</div>
					)}
				</form>
			</div>
		)
	}

	componentDidMount() {
		this.getExistingTeachers()
	}
}

CleverProvisioningForm.propTypes = PageStrictPropTypes({
	accessToken: PropTypes.object,
	onSubmit: PropTypes.func
});

module.exports = CleverProvisioningForm;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverProvisioningForm.js